import Button from 'components/button';
import CardHover from 'components/cardHover';
import CTAStyleWrapper from './CTA.style';
import { useTranslation } from 'react-i18next';

const CTA = () => {
  const { t } = useTranslation();
  return (
    <CTAStyleWrapper>
      <div className="container">
        <div className="cta-area text-center">
          <h2 className="title">
            {t('footer.title1')} <br />
            {t('footer.title2')}
          </h2>
          {/* <div className="dsc">
            If you want to lanuch an IGO/IDO, It will be your perfect choice
          </div> */}
          <Button variant="mint" md href="/sale-submission">
            {t('footer.buyButton')}
          </Button>
          <CardHover />
        </div>
      </div>
    </CTAStyleWrapper>
  );
};

export default CTA;
